import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import CustomNavigate from '../components/CustomNavigate';

export default function InvitationMiddleware({ children }) {
    const location = useLocation();
    const { user } = useAuth();

    const searchParams = new URLSearchParams(location.search);
    const tokenFromQuery = searchParams.get('organizationInvitationToken');
    // El token también puede venir en el path: /auth/accept-invitation/:token
    const tokenFromPath = location.pathname.match(/\/accept-invitation\/([^/]+)/)?.[1];
    const token = tokenFromQuery || tokenFromPath;

    if (token) {
        // 🔥 Asegurar que el token siempre viaje en el query, incluso sin login,
        // para que los redirects (login, email verify) lo conserven
        if (!tokenFromQuery) {
            return <CustomNavigate to={location.pathname} params={{ organizationInvitationToken: token }} replace />;
        }

        // 🔥 Usuario logeado fuera de accept-invitation → llevarlo a aceptar la invitación
        if (user && !location.pathname.includes('/accept-invitation')) {
            return <CustomNavigate to={`/auth/accept-invitation/${token}`} replace />;
        }
    }

    return children;
}

InvitationMiddleware.propTypes = {
    children: PropTypes.node.isRequired,
};
